export function takeAuthCallbackToken(): string | null {
  const hash = new URLSearchParams(window.location.hash.slice(1));
  const query = new URLSearchParams(window.location.search);
  const token = hash.get('token');

  if (hash.has('token') || query.has('token')) {
    window.history.replaceState(null, '', window.location.pathname);
  }
  return token;
}
